<!------------------------------------------------------------------------------
 File: CardBasic 
 Created by keni.
 with: IntelliJ IDEA
 Date: 09/05/2018
 Time: 16:06
------------------------------------------------------------------------------->
<template>
   <div class="card" :class="cls">

       <div class="card-body">
           <slot name="close"></slot>
           <div class="card-title">
               <slot name="header"></slot>
               <slot name="sub-header"></slot>
           </div>
           <slot>

           </slot>
       </div>

   </div>

</template>

<script>
	export default {
		name: "card-basic",
		components: {},
		props: {
			body_class:String,
			cls:String
        },
		created() {
		},
		destroyed() {
		},
		mounted() {

		},
		data() {
			return {}
		},
		methods: {},
		watch: {},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/cards/CardBasic.vue?8d61b950